module.exports = __webpack_public_path__ + "r-v3/img/set_doc.bc08fb91.svg";